<template>
  <v-dialog
    v-model="isVisible"
    max-width="1200"
    persistent
    scrollable
  >
    <v-card>
      <v-toolbar
        color="secondary"
        dark
        tile
      >
        <v-toolbar-title>
          Edit Imported Party from Oregon Worker Relief Fund
        </v-toolbar-title>

        <v-spacer />

        <v-btn
          icon
          @click="_ => closeDialog()"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider />

      <v-card-text
        class="pa-0"
        style="height: 70vh; position: relative;"
      >
        <LegalCaseEditorImportPartyEdit
          v-model="partyData"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-btn
          text
          @click="_ => closeDialog()"
        >
          Cancel
        </v-btn>

        <v-spacer />

        <v-btn
          color="success"
          @click="_ => saveParty()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { isEmpty } from 'lodash'

import LegalCaseEditorImportPartyEdit from './LegalCaseEditorImportPartyEdit.vue'

export default {
  name: 'LegalCaseEditorImportedPartyEditorDialog',

  components: {
    LegalCaseEditorImportPartyEdit,
  },

  model: {
    prop: 'visible',
    event: 'change',
  },

  props: {
    party: {
      required: true,
      type: Object,
    },

    visible: {
      required: true,
      type: Boolean,
    },
  },

  data () {
    return {
      partyData: null,
    }
  },

  computed: {
    isVisible: {
      get () { return this.visible },
      set (value) { this.$emit('change', value === true) },
    },
  },

  watch: {
    party: {
      deep: true,

      handler (value) {
        this.partyData = value
      },

      immediate: true,
    },
  },

  methods: {
    closeDialog () {
      this.isVisible = false
    },

    saveParty () {
      if (!this.partyData.email?.no_email && !isEmpty(this.partyData.email?.address)) {
        this.partyData.email.primary = true
      }

      if (!isEmpty(this.partyData.phone?.phone_number)) {
        this.partyData.phone.preferred_text = true
        this.partyData.phone.preferred_voice = true
      }

      this.$emit('save', {
        ...this.partyData,
        primary_email: this.partyData.email,
        primary_text_number: this.partyData.phone,
      })

      this.closeDialog()
    },
  },
}
</script>
